//LOGOS
import logo from '../assets/imgs/logo-rc.png'
import open from '../assets/icons/in.svg'
import close from '../assets/icons/out.svg'
import key from '../assets/icons/key.svg'
import during from '../assets/icons/during.svg'

export const rawCategories = [
    {
      id: '1',
      catName: 'Ouverture',
      linkTo: '/bar/cat/1',
      icon: open,
      desc: [
        {
           tag: 'p',
           content: "L'idée est de <b>mettre en priorité le bar dans un mood accueillant</b> :) Voici donc une proposition d'ordre des trucs à mettre en place.",
           attr: {className: 'cat-desc'}
        }
      ]
    },
    {
      id: '2',
      catName: 'Fermeture',
      linkTo: '/bar/cat/2',
      icon: close,
      desc: [
        {
           tag: 'p',
           content: "L'idée est de laisser le bar dans le meilleur état possible pour le ou la suivant.e,  <b>vaisselle faite et frigo remplis</b> :)",
           attr: {className: 'cat-desc'}
        }
      ]
    },
    {
      id: '3',
      catName: 'Pendant le shift',
      linkTo: '/bar/cat/3',
      icon: during,
      desc: [
        {
           tag: 'p',
           content: "Outre votre sourire et votre bonne humeur pendant le shift, quand le spectacles est cours, c'est super d'en profiter pour <b>remettre les tables et le bar dans l'état de début de soirée</b>. :)",
           attr: {className: 'cat-desc'}
        }
      ]
    },
    {
      id: '4',
      catName: 'Mots de passe',
      linkTo: '/bar/cat/4',
      icon: key,
      desc: [
        {
          tag: 'p',
          content: "En attendant que l'app soit sécurisée et qu'ils puissent s'afficher ici, vous les trouverez sur <a target='_new' href='https://app.asana.com/0/1147233130681153/1175129415968197/f'> Asana</a> :) !",
          attr: {className: 'cat-desc'}
        }
      ]
    },
  ]
  